import styled from 'styled-components';

export const FinePrintArticle = styled.article`
  margin-bottom: 55px;
  padding-bottom: 50px;
`;

export const FinePrintHeading = styled.h2`
  margin: 0;
  margin-bottom: 15px;
  padding: 0;
  
  font-size: 16px;
  line-height: 1;
  
  @media (min-width: 768px){
    font-size: 24px;
    margin-bottom: 25px;
  }
`;

export const FinePrintList = styled.ul`
  li {
    position: relative;
    
    padding-left: 18px;
    
    font-size: 14px;
    line-height: 18px;
    
    @media (min-width: 768px){
      font-size: 16px;
    }
    
    &:not(:last-child) {
      margin-bottom: 9px;
      
      @media (min-width: 768px){
        margin-bottom: 15px;
      }
    }
    
    &::before {
      content: "";
      
      position: absolute;
      top: 5px;
      left: 0;
      
      width: 6px;
      height: 6px;
      
      border-radius: 50%;
      background-color: #a8a8a8;
    }
  }
`;
